const useResponseHandler = () => {
  const handleResponse = async (response) => {
    // Check for empty response body
    const contentLength = response.headers.get('content-length')
    if (contentLength === '0') {
      throw new Error(
        `Service returned ${response.status} with empty response body.`
      )
    }

    if (!response.ok) {
      const json = await response.json()
      let errors =
        json._embedded && json._embedded.errors
          ? json._embedded.errors.map((item) => item.message).join('\n')
          : json.message
      if (!errors) {
        errors = `Service returned ${response.status} ${response.statusText}`
      }
      throw new Error(errors)
    }
  }

  return { handleResponse }
}

export { useResponseHandler }
